// Configuration de l'URL de l'API
export const API_URL = process.env.REACT_APP_API_URL || 'https://logs.arketype-script.com';
